var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [
            { icon: "file-invoice-dollar", page: _vm.page_title.toUpperCase() },
          ],
        },
      }),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _vm.create_access
            ? _c(
                "v-btn",
                {
                  staticClass: "mb-5",
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialog_bulk_upload = true
                    },
                  },
                },
                [_vm._v("Carga masiva")]
              )
            : _vm._e(),
          _vm.create_access
            ? _c(
                "v-btn",
                {
                  staticClass: "mb-5 ml-3",
                  attrs: { outlined: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialog_upload_payslip = true
                    },
                  },
                },
                [_vm._v("Carga individual")]
              )
            : _vm._e(),
          _c("PayslipList", { ref: "payslips" }),
          _c("ModalBulkUpload", {
            attrs: { dialog: _vm.dialog_bulk_upload },
            on: {
              updateDialog: (value) => (_vm.dialog_bulk_upload = value),
              imported: _vm.reloadList,
            },
          }),
          _c("ModalUploadPayslip", {
            attrs: { dialog: _vm.dialog_upload_payslip },
            on: {
              updateDialog: (value) => (_vm.dialog_upload_payslip = value),
              uploaded: _vm.reloadList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }